module.exports = __webpack_public_path__ + "assets/icons/ic_cloud_upload-303d.svg";